/**
 * GENERATED by `bun run scripts/sync-field-labels.ts`. Do not edit.
 *
 * @remarks
 * Labels for request field names and their selectable options, in hi. Importing this module
 * registers them and re-renders every mounted form, exactly like the chrome catalogue beside it.
 * Regenerate with `bun run generate`; the source of truth is the API, not this file.
 */

import { registerFieldLabels } from '../../i18n/registry.js';

registerFieldLabels('hi', {
	fields: {
		allowDuplicates: 'डुप्लिकेट कार्ड की अनुमति दें',
		allowReversals: 'उल्टे कार्ड की अनुमति दें',
		antardasha: 'अंतर्दशा',
		approximateDate: 'अनुमानित तिथि',
		arcana: 'आर्काना',
		aspectTypes: 'दृष्टि प्रकार',
		avasthaInfo: 'अवस्था विवरण शामिल करें',
		ayanamsa: 'अयनांश',
		ayanamsaValue: 'कस्टम अयनांश मान',
		biorhythm: 'बायोरिदम',
		birthData: 'जन्म विवरण',
		birthDate: 'जन्म तिथि',
		birthLatitude: 'जन्म अक्षांश',
		birthLongitude: 'जन्म देशांतर',
		birthTime: 'जन्म समय',
		chakra: 'चक्र',
		color: 'रंग',
		context: 'आपने इसे कहाँ देखा',
		coordinateSystem: 'निर्देशांक प्रणाली',
		count: 'कितने',
		currentYear: 'वर्ष',
		date: 'तिथि',
		datetime: 'तिथि और समय',
		day: 'दिन',
		division: 'वर्ग कुंडली',
		domainWeights: 'डोमेन भार',
		domains: 'डोमेन',
		element: 'तत्व',
		endDate: 'अंत तिथि',
		endDatetime: 'अंत तिथि और समय',
		expression: 'अभिव्यक्ति अंक',
		family: 'योग वर्ग',
		focus: 'फोकस',
		fullName: 'पूरा नाम',
		horaryNumber: 'प्रश्न संख्या',
		houseSystem: 'भाव पद्धति',
		id: 'आईडी',
		include: 'अतिरिक्त पिंड',
		interpretation: 'स्थिति का अर्थ',
		intervalMinutes: 'अंतराल (मिनट में)',
		iso2: 'देश कोड',
		lang: 'भाषा',
		latitude: 'अक्षांश',
		letter: 'प्रारंभिक अक्षर',
		lifePath: 'जीवन पथ अंक',
		limit: 'प्रति पृष्ठ परिणाम',
		lines: 'रेखा पैटर्न',
		longitude: 'देशांतर',
		mahadasha: 'महादशा',
		members: 'समूह सदस्य',
		minSignificance: 'न्यूनतम महत्व',
		minStrength: 'न्यूनतम शक्ति',
		modernPlanets: 'आधुनिक ग्रह शामिल करें',
		month: 'महीना',
		name: 'नाम',
		natalChart: 'जन्म कुंडली',
		nodeType: 'चंद्र नोड प्रकार',
		number: 'संख्या',
		offset: 'छोड़े गए परिणाम',
		orb: 'ऑर्ब',
		person1: 'व्यक्ति 1',
		person2: 'व्यक्ति 2',
		personA: 'व्यक्ति A',
		personB: 'व्यक्ति B',
		planet: 'ग्रह',
		planets: 'ग्रह',
		positions: 'स्प्रेड स्थितियाँ',
		pratyantardasha: 'प्रत्यंतर्दशा',
		q: 'खोजें',
		question: 'आपका प्रश्न',
		relocationLatitude: 'स्थानांतरण अक्षांश',
		relocationLongitude: 'स्थानांतरण देशांतर',
		returnDate: 'वापसी तिथि',
		returnYear: 'वापसी वर्ष',
		scheme: 'कारक पद्धति',
		seed: 'सीड',
		sign: 'राशि',
		significators: 'KP कारक शामिल करें',
		sookshma: 'सूक्ष्म',
		soulUrge: 'सोल अर्ज अंक',
		spreadName: 'स्प्रेड नाम',
		startDate: 'आरंभ तिथि',
		startDatetime: 'आरंभ तिथि और समय',
		strictOrbs: 'संकरे ऑर्ब का उपयोग करें',
		suit: 'सूट',
		system: 'अवस्था प्रणाली',
		targetDate: 'लक्ष्य तिथि',
		targetMonth: 'लक्ष्य माह',
		time: 'समय',
		timezone: 'समय क्षेत्र',
		top: 'प्रति विंडो शीर्ष घटनाएँ',
		transitDate: 'गोचर तिथि',
		transitTime: 'गोचर समय',
		type: 'पैटर्न प्रकार',
		vedic: 'वैदिक',
		western: 'पश्चिमी',
		year: 'वर्ष',
		zodiac: 'राशि',
	},
	enums: {
		'arcana.major': 'मेजर आर्काना',
		'arcana.minor': 'माइनर आर्काना',
		'ayanamsa.custom': 'कस्टम',
		'ayanamsa.kp-newcomb': 'केपी न्यूकॉम्ब',
		'ayanamsa.kp-old': 'पुराना केपी',
		'ayanamsa.lahiri': 'लाहिरी',
		'ayanamsa.raman': 'बी.वी. रामन',
		'chakra.Crown': 'सहस्रार',
		'chakra.Heart': 'अनाहत',
		'chakra.Root': 'मूलाधार',
		'chakra.Sacral': 'स्वाधिष्ठान',
		'chakra.Solar Plexus': 'मणिपूर',
		'chakra.Third Eye': 'आज्ञा',
		'chakra.Throat': 'विशुद्ध',
		'context.address': 'पता',
		'context.clock': 'घड़ी',
		'context.license-plate': 'लाइसेंस प्लेट',
		'context.phone': 'फोन नंबर',
		'context.price': 'कीमत',
		'context.receipt': 'रसीद',
		'coordinateSystem.sidereal': 'निरयन',
		'coordinateSystem.tropical': 'सायन',
		'element.Air': 'वायु',
		'element.Earth': 'पृथ्वी',
		'element.Fire': 'अग्नि',
		'element.Storm': 'तूफ़ान',
		'element.Water': 'जल',
		'family.akriti': 'आकृति',
		'family.asraya': 'आश्रय',
		'family.classical': 'शास्त्रीय',
		'family.dala': 'दल',
		'family.sankhya': 'संख्या',
		'focus.finance': 'वित्त',
		'focus.general': 'सामान्य',
		'houseSystem.equal': 'समान',
		'houseSystem.koch': 'कोच',
		'houseSystem.placidus': 'प्लासिडस',
		'houseSystem.whole-sign': 'पूर्ण राशि',
		'lang.de': 'जर्मन',
		'lang.en': 'अंग्रेज़ी',
		'lang.es': 'स्पेनिश',
		'lang.fr': 'फ्रेंच',
		'lang.hi': 'हिन्दी',
		'lang.pt': 'पुर्तगाली',
		'lang.ru': 'रूसी',
		'lang.tr': 'तुर्की',
		'nodeType.mean': 'मध्यम नोड',
		'nodeType.true': 'स्पष्ट नोड',
		'planet.Jupiter': 'बृहस्पति',
		'planet.Mars': 'मंगल',
		'planet.Mercury': 'बुध',
		'planet.Saturn': 'शनि',
		'planet.Venus': 'शुक्र',
		'scheme.eight': 'आठ कारक',
		'scheme.seven': 'सात कारक',
		'suit.cups': 'प्याला',
		'suit.pentacles': 'पेंटाकल',
		'suit.swords': 'तलवार',
		'suit.wands': 'छड़ी',
		'system.baladi': 'बालादि',
		'system.deeptadi': 'दीप्तादि',
		'system.jagradadi': 'जाग्रदादि',
		'type.compound': 'संयुक्त',
		'type.master': 'मास्टर',
		'type.mirror': 'दर्पण',
		'type.repeating': 'दोहराव',
		'type.root': 'मूलांक',
		'type.sequential': 'क्रमबद्ध',
		'zodiac.aquarius': 'कुंभ',
		'zodiac.aries': 'मेष',
		'zodiac.cancer': 'कर्क',
		'zodiac.capricorn': 'मकर',
		'zodiac.gemini': 'मिथुन',
		'zodiac.leo': 'सिंह',
		'zodiac.libra': 'तुला',
		'zodiac.pisces': 'मीन',
		'zodiac.sagittarius': 'धनु',
		'zodiac.scorpio': 'वृश्चिक',
		'zodiac.taurus': 'वृषभ',
		'zodiac.virgo': 'कन्या',
	},
});
